export const headers = [
  { key: "requestId", label: "Request ID" },
  { key: "businessName", label: "Business Name" },
  { key: "primaryContactName", label: "Primary Contact Name" },
  { key: "businessType", label: "Business Type" },
  { key: "requestedDate", label: "Request Date" },
  { key: "status", label: "Status" },
];

export const plannerRequestFilterOptions = [
  {
    label: "Status",
    value: "status",
    type: "checkbox",
    options: [
      { label: "Pending", value: "pending" },
      { label: "Approved", value: "approved" },
      { label: "Rejected", value: "rejected" },
    ],
  },
  {
    label: "Business Type",
    value: "businessType",
    type: "checkbox",
    options: [
      { value: "Preneed Planner", label: "Preneed Planner" },
    ],
  },
  {
    label: "Requested Date Range",
    value: "requestedDateRange",
    type: "dateRange",
  },
];
